/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LicenseType } from '../../models/license-type';
import { LicenseTypeCriteria } from '../../models/license-type-criteria';

export interface ApiMasterLicenseTypeGetByCriteriaPost$Params {
      body?: LicenseTypeCriteria
}

export function apiMasterLicenseTypeGetByCriteriaPost(http: HttpClient, rootUrl: string, params?: ApiMasterLicenseTypeGetByCriteriaPost$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LicenseType>>> {
  const rb = new RequestBuilder(rootUrl, apiMasterLicenseTypeGetByCriteriaPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<LicenseType>>;
    })
  );
}

apiMasterLicenseTypeGetByCriteriaPost.PATH = '/api/Master/LicenseType/GetByCriteria';
